import { Box } from '@material-ui/core'
import RegularButton from 'components/CustomButtons/Button'
import React, { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { editEndowmentMobile } from 'redux/actions/routesStatus/routesStatusAction'

export const EndowmentsSubmit = ({onClose, total, data, form}) => {
  const [disabled, setDisabled] = useState(false)
  const dispatch = useDispatch()

  useEffect(() => {
    if(data.type === 'PORTATIL') {
      total > 30 || total === 0 ? setDisabled(true) : setDisabled(false)
    }
  }, [total, data])

  const handleSubmit = (e) => {
    e.preventDefault()
    if(data.type === 'PORTATIL'){
      const { capacity, flowmeter, rotogauge, ...newForm } = form
      dispatch(editEndowmentMobile(data.idUnit, newForm, true , onClose))
    } else {
      const newForm = {
        // idRoute: data.route,
        idDispenser: data.idDispenser,
        flowmeter: parseInt(form?.flowMeter),
        rotogauge: parseInt(form.rotogauge)
      }

      dispatch(editEndowmentMobile(data.id, newForm, false , onClose))
    }
  }

  return (
    <Box style={{
      display: 'flex',
      flexGrow: 1,
      gap: 10,
      marginTop: 30
    }}>
      <RegularButton color="danger" fullWidth onClick={onClose}>Cancelar</RegularButton>
      <RegularButton 
        color="info"
        fullWidth
        disabled={disabled}
        onClick={handleSubmit}
      >Guardar</RegularButton>
    </Box>
  )
}
